<template>
  <div class="page">
    <PageHeader
      title="전학생 추가 발급"
    />

    <div class="page__sections">
      <FormCard>
        <template #header>
          <div class="card-header">
            <div class="card-header__title">신청 처리</div>
            <v-btn
              variant="flat"
              color="primary"
              size="small"
              @click="applyTableRef?.issueAllPending()"
            >
              전체 발급
            </v-btn>
          </div>
        </template>
        <ApplyTable ref="applyTableRef" />
      </FormCard>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import PageHeader from "@/components/ui/PageHeader.vue";
import FormCard from "@/components/ui/FormCard.vue";
import ApplyTable from "./ListTransferStudentTableComponent.vue";

const applyTableRef = ref(null);
</script>

<style scoped>
.page {
  padding: var(--space-8);
  max-width: 1400px;
  margin: 0 auto;
}

.page__sections {
  display: flex;
  flex-direction: column;
  gap: var(--space-6);
}

.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-3);
}

.card-header__title {
  font-size: var(--font-h3-size);
  line-height: var(--font-h3-line);
  font-weight: var(--font-h3-weight);
  color: var(--text-primary);
}
</style>
